import { render } from "./About.vue?vue&type=template&id=83ab445c"
const script = {}
script.render = render

export default script